import { render } from "./BenchmarkViewWilandDashboard.vue?vue&type=template&id=4ad3e3ce"
import script from "./BenchmarkViewWilandDashboard.vue?vue&type=script&lang=js"
export * from "./BenchmarkViewWilandDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/BenchmarkViewWilandDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ad3e3ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ad3e3ce', __exports__)) {
    api.reload('4ad3e3ce', __exports__)
  }
  
  module.hot.accept("./BenchmarkViewWilandDashboard.vue?vue&type=template&id=4ad3e3ce", () => {
    api.rerender('4ad3e3ce', render)
  })

}


export default __exports__